export class KazMonEventOptions {
  public traceToken: string | undefined
  public correlationToken: string | undefined
  public appVersion: string | undefined
  public identity: string | undefined
}
